import React from "react";
import { marked } from "marked";
import PropTypes from "prop-types";
import DOMPurify from "isomorphic-dompurify";

const customRenderer = new marked.Renderer();
customRenderer.heading = (text) => text;
customRenderer.link = (_href, _title, text) => text;

const markedOptions = {
  breaks: true,
  renderer: customRenderer,
};

const parseDescription = (description = "", customOptions = {}) => {
  marked.use({ ...markedOptions, ...customOptions });

  return DOMPurify.sanitize(
    marked.parse(
      description
        ?.replace(/\\{2}/g, "\n") // \\ => \n
        ?.replace(/,(\S)/g, ", $1") // foo,bar => foo, bar
        ?.replace(/\n(?=\n)/g, "\n\n<br />\n"),
    ),
    {
      ADD_ATTR: ["target"],
    },
  );
};

export function MarkdownViewer({
  content,
  customOptions,
  handleCheckoutRedirect,
  ...props
}) {
  const handleButtonClick = (e) => {
    e.preventDefault();

    const { target } = e;

    if (target && target.dataset.redirect === "true") {
      return handleCheckoutRedirect();
    }

    return null;
  };

  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: parseDescription(content, customOptions),
      }}
      onClick={(e) => handleButtonClick(e)}
      {...props}
    />
  );
}

MarkdownViewer.defaultProps = {
  customOptions: {},
};

MarkdownViewer.propTypes = {
  content: PropTypes.string.isRequired,
  customOptions: PropTypes.object,
};
